import { Badge, Box, Button, Center, Container, Heading, HStack, Image, SimpleGrid, Spacer, Spinner, Text, Wrap, WrapItem } from '@chakra-ui/react'
import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom';
import AuthContext from '../Routes/hooks/AuthContext';

function ProductPage() {
	const { products } = useContext(AuthContext)
	return (
		<>


				<Wrap justify='center'>
					<WrapItem>
						<Text>Ayam</Text>
					</WrapItem>
					<WrapItem>
						<Text>Bisnis Model</Text>
					</WrapItem>
					<WrapItem>
						<Text>Ideation</Text>
					</WrapItem>
				</Wrap>

				<SimpleGrid columns={2} gap='2' mt={2}>
					{products ?
						products.map((x, i) =>
							<Link key={i} to={`/product/${x.id}`}>
								<Box shadow='base' p='1'>
									<Center>
										<Image src={x.thumbnail} />
									</Center>
									<Badge fontSize='2xs' bgColor='red' color='white'>Marketing</Badge>
									<Heading fontSize='md'>{x.nama}</Heading>
									<HStack p='1'>
										<Box>
											<Text fontSize='sm'>Instructor{x.teacher}</Text>
											<Text fontSize='sm'>Founder{x.teacher_position}</Text>
										</Box>

										<Spacer />	
										<Heading textAlign='end' fontSize='sm'>IDR{Intl.NumberFormat('en-ID', { maximumSignificantDigits: 3 }).format(x.price)}</Heading>


									</HStack>
									<Button colorScheme='blue'  width='full'>Lihat</Button>

								</Box>
							</Link>

						)
						:
						<Spinner />
					}

				</SimpleGrid>
		</>
	)
}

export default ProductPage